import React from 'react'
import { Component } from 'react'
let check_icon = require('../../../theme/assets/images/check_icon.png')
class OwnerEmailVerification extends Component {
  render() {
    return (
      <div className="verified_check_block">
        <img
          width="15px"
          height="15px"
          src={check_icon}
          className="check_icon_image"
					alt="check-icon"
        />
        <p className="verification_confirmation_text">Email Address Verified</p>
      </div>
    )
  }
}
export default OwnerEmailVerification
